import React, { useState, useEffect } from 'react';
import { Button, Col, Row, Modal, ModalBody, ModalHeader } from 'reactstrap';
import HoverImage from 'react-hover-image/build';
import ReactStrapTable from 'components/reactStrapTable';
import { useNavigate } from 'react-router-dom';
import useAxios from 'hooks/useAxios';
import Drawer from "components/Drawer";
import ConfirmationDialouge from 'components/ConfirmationDialouge';
import viewClaim from 'assets/icon/icon-icon-options-view-claims.svg';
import optionAuthorizeHover from '../../../../assets/icon/icon-icon-options-order-complete-hover.svg';
import optionAuthorize from '../../../../assets/icon/icon-icon-options-order-complete.svg';
import optionCancel from '../../../../assets/icon/icon-icon-options-not-eligible.svg';
import optionCancelHover from '../../../../assets/icon/icon-icon-options-not-eligible-hover.svg';
import ViewClaimsHover from 'assets/icon/icon-icon-options-view-claims_hover.svg';
import optionView from "../../../../assets/icon/icon-icon-options-view-patient.svg";
import optionViewHove from "../../../../assets/icon/icon-icon-options-view-patient_hover.svg";
import OrderDetailsDrawer from './components/OrderDetails/OrderDetailsDrawer';
import AddOrderModal from './components/Add';
import { cellRendererCheck, dateFormate, currencyFormat } from 'utils/columns';
import ClaimsDrawer from './components/ClaimsDetails/ClaimsDrawer';
import useContextService from 'hooks/useContextService';
import { ModuleAccess } from 'utils/moduleaccess';
import DragDrop from 'components/DragDrop';
import { onExport } from 'utils/helper';
import { toast } from 'react-toastify';
import plus from "assets/icon/Add-White-Icon.svg";
import ViewPo from "assets/icon/ViewPo.svg";
import ViewPoHover from "assets/icon/ViewPoHower.svg";
import { cloneDeep } from 'lodash';


let selectedRow = {};
let tableDataBackup = [];
let autoselectlist1 = [];
let numberlist = ['PO Number', 'Total Packages Ordered', 'Total Ordered Price', 'Total Invoiced Packages']
let currencylist = ['Total Ordered Price', 'Total Invoiced Price']
let dateList = ['PO Date',]
let editlist = ['Claim Status', 'Reason']
let hideColFilterlist = ['PO Date', 'Source PO #', 'PO Number']
let hideSortColFilterList = ['PO Date', 'PO Number']
let isRole = ["GWPHA", "GWPHU"];
let addPODisable = ["SUPADM", "GWPFA", "GWCPA"]
let pharmacyWidth = ['Pharmacy','Chain Pharmacy', 'Covered Entity'];

const PurchaseOrderTable = (props) => {
  const {
    data,
    totalSize,
    loading,
    onPageChange,
    AllExport,
    slelectedExport,
    filters,
    onSearchColumnFilters = () => '',
    thirdPartyAdmin,
    refetch,
    selectedOption,
    selectedOpt,
    toggleSider,
    collapseSider,
    accountype,
    setAccountype,
    Non340BTenantID,
    cpId  
  } = props;

  let modulename = accountype == 1 ? "PurchaseOrders" : "Non340BPurchaseOrders";

  const API = useAxios();
  const {
    states: { purchaseOrder },
    setStates,
    resetStates,
  } = useContextService();
  useEffect(() => {
    handlAutocoloms();
  }, [accountype]);
  tableDataBackup = data;
  const navigate = useNavigate();
  const [poRowData, setPORowData] = useState({});
  const [tableData, setTableData] = useState(tableDataBackup);
  const [reset, setReset] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isPODetailsOpen, setisPODetailsOpen] = useState(false);
  const [disableSelectedColumn, setDisableSelectedColumn] = useState(false);
  const [drawerPODetails, setDrawerPODetails] = useState('');
  const [isClaimsPOOpen, setisClaimsPOOpen] = useState(false);
  const [drawerClaimsPO, setDrawerClaimsPO] = useState('');
  const [coloumselect, setColoumselect] = useState(false);
  const [isAuthorizeOrderOpen, setisAuthorizeOrderOpen] = useState(false);
  const { thirdPartyAdminID, tenantID } = thirdPartyAdmin;
  const [conformLoading, setConformLoading] = useState(false);
  const [isCancelOrderOpen, setisCancelOrderOpen] = useState(false);
  const [hasExportPermission, setHasExportPermission] = useState(false);
  const pharmaforce = sessionStorage.getItem("pharmaforce");
  const [totalItem, setTotalItem] = useState(0);
   const [columnFilters, setColumnFilters] = useState([]);
  const [data1, setData] = useState()
  const { token_type, access_token, profile } =
    JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
  const { roles } = profile || {};
  console.log(roles, "roles")
  var con = isRole.includes(roles);
  console.log(con, "con")
  var isDisable = addPODisable.includes(roles);
  console.log(isDisable, "isDisable");
  const { search, searchTerms } =

    purchaseOrder;
  const { ceIds, pharmacyids } =
    searchTerms;
  useEffect(() => {
    setTableData(data);
    tableDataBackup = data;
  }, [data]);

  useEffect(() => {
    setHasExportPermission(ModuleAccess("PO", "EXP"));
  }, []);

  const handlAutocoloms = async () => {
    autoselectlist1 = [];
    try {
      const { data } = await API.get(`GWConfig/coveredentity/autoselectcoloumslist/${modulename}`, {
        hasDefaultURL: true,
      });
      if (data) {
        if (data.length > 0) {
          setDisableSelectedColumn(false);
        } else {
          setDisableSelectedColumn(true);
        }

        for (var x in data) {
          autoselectlist1.push({ "text": data[x].displayName, "dataField": data[x].fieldName });

        }
      }

    } catch (err) {

    }
  }
  const [ClaimDrawer, setClaimDrawer] = useState(false);

  const toggleClaimDrawer = (rowData) => {
    setClaimDrawer((pre) => !pre);
  };
  const handleselectColoums = () => {
    setColoumselect(!coloumselect);
  }
  const togglePODetailsDrawer = () => {
    setisPODetailsOpen(!isPODetailsOpen);
    setDrawerPODetails('');
  };

  const handleAuthorizeOrderConformation = () => {
    setisAuthorizeOrderOpen(!isAuthorizeOrderOpen);
  };

  const handleCancelOrderConfirmation = () => {
    setisCancelOrderOpen(!isCancelOrderOpen);
  };

  const drawerPODetailsClose = (hasUpdated) => {
    setisPODetailsOpen(!isPODetailsOpen);
    setDrawerPODetails('');
    if (hasUpdated) refetch();
  };
  const handlePODetails = (row) => {
    setisPODetailsOpen(!isPODetailsOpen);
    setDrawerPODetails('OrderDetails');
    setPORowData(row);
  };
  const slelectedExportcoloumms = async () => {
    // const { access_token } =
    //   JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
    // const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/PurchaseOrder/SelectedExportAll/${searchTerms.thirdPartyAdminID || 0}/${searchTerms.wholesalerID || 0}?access_token=${access_token}`;
    // onExport(action, filters);

    const filterObj = cloneDeep(search);
      if (columnFilters && columnFilters.length > 0) {
        filterObj.filters = [...filterObj.filters, ...columnFilters];
      }
  
      var additionalCriteria = {};
      additionalCriteria.IsSelectedColumn = true;
      filterObj.TPAId = searchTerms.thirdPartyAdminID || 0;
      filterObj.WholesalerId = searchTerms.wholesalerID || 0;
      //additionalCriteria.OrgId = orgId.organizationID;
      var payload = {};
      payload.tenantID = tenantID;
      payload.gridCode = "purchaseorder";
      payload.fileTypeCode = "csv";
      payload.criteria = JSON.stringify(filterObj);
      payload.additionalCriteria = JSON.stringify(additionalCriteria);
      const { data } = await API.post(`export/queue`, payload, {
        hasExport: true,
      });
  }

  const slelectedNon340BExportcoloumms = async () => {
    const { access_token } =
      JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
    const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${Non340BTenantID}/PurchaseOrder/Non340BSelectedExportAll/${cpId}?access_token=${access_token}`;
    onExport(action, filters);

  }

  const toggleClaimsPODrawer = () => {
    setisClaimsPOOpen(!isClaimsPOOpen);
    setDrawerClaimsPO('');
  };

  const drawerClaimsPOClose = (hasUpdated) => {
    setisClaimsPOOpen(!isClaimsPOOpen);
    setDrawerClaimsPO('');
    if (hasUpdated) refetch();
  };
  const handleClaimsPO = (row) => {
    setisClaimsPOOpen(!isClaimsPOOpen);
    setDrawerClaimsPO('POClaims');
    setPORowData(row);
  };

  const cellRenderLink = (rowData) => {
    return (
      <span>
        {rowData.poid}
      </span>
    );
  };

  const setCancelOrder = (rowData) => {
    setData(rowData)
    selectedRow = {};
    selectedRow = rowData;
    handleCancelOrderConfirmation();
  };

  const setAuthorizeOrder = (rowData) => {
    setData(rowData)
    selectedRow = {};
    selectedRow = rowData;
    handleAuthorizeOrderConformation();
  };

  const cellOptionLinks = (rowData) => {
    if (rowData.poStatusID == 5070) {
      return (
        <Button color='link' onClick={() => handleClaimsPO(rowData)}>
          <HoverImage src={optionView} hoverSrc={optionViewHove} alt />
        </Button>
      );
    }
  };

  const renderClaimsPOButton = (rowData) => {
    if (rowData.poStatusID == 5070 || rowData.poStatusID == 5080) {
      return (
        <Button
          className="text-primary p-0 text-decoration-none"
          color='link'
          onClick={() => handleClaimsPO(rowData)}
          title="PO# Claims"
        >
          <HoverImage
            key="veiwPOCLaims"
            src={viewClaim}
            hoverSrc={ViewClaimsHover}
            alt=""
          />
        </Button>
      );
    }
  }
  const renderPODetails = (rowData) => {
    return (
      <Button
        className="text-primary p-0 text-decoration-none"
        color="link"
        onClick={() => handlePODetails(rowData)}
        title="Purchase Order Details"
      >
        {/* {rowData.poid} */}
        <HoverImage
          key="ViewClaim"
          src={ViewPo}
          hoverSrc={ViewPoHover}
          alt=""
        />
      </Button>
    );
  };


  const renderCancelOrderButton = (rowData) => {
    if (hasPermission("POCAN") && (rowData.poStatusID == 5010)) {
      return (
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => setCancelOrder(rowData)}
          title='Order Cancel'
        >
          <HoverImage
            key="OrderCancel"
            src={optionCancel}
            hoverSrc={optionCancelHover}
            alt=''
          />
        </Button>
      )
    }
  };


  const renderAuthorizeOrderButton = (rowData) => {
    if (hasPermission("POAUTH") && (rowData.poStatusID == 5010)) {
      return (
        <Button
          className="text-primary p-0 text-decoration-none"
          color="link"
          onClick={() => setAuthorizeOrder(rowData)}
          title='Order Authorize'
        >
          <HoverImage
            key="OrderAuthorize"
            src={optionAuthorize}
            hoverSrc={optionAuthorizeHover}
            alt=''
          />
        </Button>
      )
    }
  }

  const handleAuthorizeSubmit = async () => {
    handleAuthorizeOrderConformation();
    setConformLoading(false);
    try {
      const { data } = await API.get(
        `/${tenantID}/PurchaseOrder/orderauthorize/${selectedRow.poid}`
      );

      toast.success("Authorized Order successfully");
      setisAuthorizeOrderOpen(!isAuthorizeOrderOpen);
      refetch();

      selectedRow = {};
      if (data) {
        setData(data.items);
        setTotalItem(data.totalRecords);
      } else {

        setConformLoading(true);
      }
    } catch (error) {
      setConformLoading(false);
    }
  };

  const handleCancelSubmit = async () => {
    handleCancelOrderConfirmation();
    setConformLoading(false);
    try {
      const data = await API.get(
        `/${tenantID}/PurchaseOrder/ordercancel/${selectedRow.poid}`
      );

      toast.success("Cancel Order successfully");
      setisCancelOrderOpen(!isCancelOrderOpen);
      refetch();
      selectedRow = {};

      if (data) {
        setData(data.items);
        setTotalItem(data.totalRecords);
      } else {

        setConformLoading(true);
        //renderAuthorizeOrderButton();
        renderCancelOrderButton();
      }
    } catch (error) {
      setConformLoading(false);
    }
  };


  const cellOptionLink = (rowData) => {
    return (
      <div className="d-flex align-items-center">
        {renderPODetails(rowData)}
        {accountype == 1 &&
          renderClaimsPOButton(rowData)}
        {accountype == 1 && renderCancelOrderButton(rowData)}
        {accountype == 1 && renderAuthorizeOrderButton(rowData)}
      </div>
    );
  };


  let maincol1 = [
    {
      dataField: 'options',
      text: 'Options',
      sort: false,
      width: 100,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellOptionLink(rowData),
      action: true,
    },
    {
      dataField: autoselectlist1[0]?.dataField,
      text: autoselectlist1[0]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[0]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[0]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[0]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > 0 ? true : false,
      inputType: dateList.includes(autoselectlist1[0]?.text) ? "date" : numberlist.includes(autoselectlist1[0]?.text) ? "number" : "text",
      width:  pharmacyWidth.includes(autoselectlist1[0]?.text) ? 288 : 144,      
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[0]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterList.includes(autoselectlist1[0]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[1]?.dataField,
      text: autoselectlist1[1]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[1]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[1]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[1]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width:  pharmacyWidth.includes(autoselectlist1[1]?.text) ? 288 : 144,      
      show: autoselectlist1.length > [1] ? true : false,
      inputType: dateList.includes(autoselectlist1[1]?.text) ? "date" : numberlist.includes(autoselectlist1[1]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[1]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterList.includes(autoselectlist1[1]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[2]?.dataField,
      text: autoselectlist1[2]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[2]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[2]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[2]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [2] ? true : false,
      inputType: dateList.includes(autoselectlist1[2]?.text) ? "date" : numberlist.includes(autoselectlist1[2]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[2]?.text) ? true : false,
      width:  pharmacyWidth.includes(autoselectlist1[2]?.text) ? 288 : 144,      
      action: true,
      edit: false,
      sort: hideSortColFilterList.includes(autoselectlist1[2]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[3]?.dataField,
      text: autoselectlist1[3]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[3]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[3]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[3]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [3] ? true : false,
      inputType: dateList.includes(autoselectlist1[3]?.text) ? "date" : numberlist.includes(autoselectlist1[3]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[3]?.text) ? true : false,
      action: true,
      width:  pharmacyWidth.includes(autoselectlist1[3]?.text) ? 288 : 144,      
      edit: false,
      sort: hideSortColFilterList.includes(autoselectlist1[3]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[4]?.dataField,
      text: autoselectlist1[4]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[4]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[4]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[4]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width:  pharmacyWidth.includes(autoselectlist1[4]?.text) ? 288 : 144,      
      show: autoselectlist1.length > [4] ? true : false,
      inputType: dateList.includes(autoselectlist1[4]?.text) ? "date" : numberlist.includes(autoselectlist1[4]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[4]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterList.includes(autoselectlist1[4]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[5]?.dataField,
      text: autoselectlist1[5]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[5]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[5]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[5]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [5] ? true : false,
      inputType: dateList.includes(autoselectlist1[5]?.text) ? "date" : numberlist.includes(autoselectlist1[5]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[5]?.text) ? true : false,
      width:  pharmacyWidth.includes(autoselectlist1[5]?.text) ? 288 : 144,      
      action: true,
      edit: false,
      sort: hideSortColFilterList.includes(autoselectlist1[5]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[6]?.dataField,
      text: autoselectlist1[6]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[6]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[6]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[6]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [6] ? true : false,
      inputType: dateList.includes(autoselectlist1[6]?.text) ? "date" : numberlist.includes(autoselectlist1[6]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[6]?.text) ? true : false,
      width:  pharmacyWidth.includes(autoselectlist1[6]?.text) ? 288 : 144,      
      action: true,
      edit: false,
      sort: hideSortColFilterList.includes(autoselectlist1[6]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[7]?.dataField,
      text: autoselectlist1[7]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[7]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[7]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[7]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [7] ? true : false,
      inputType: dateList.includes(autoselectlist1[7]?.text) ? "date" : numberlist.includes(autoselectlist1[7]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[7]?.text) ? true : false,
      width:  pharmacyWidth.includes(autoselectlist1[7]?.text) ? 288 : 144,      
      action: true,
      edit: false,
      sort: hideSortColFilterList.includes(autoselectlist1[7]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[8]?.dataField,
      text: autoselectlist1[8]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[8]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[8]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[8]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]), width: 80,
      show: autoselectlist1.length > [8] ? true : false,
      inputType: dateList.includes(autoselectlist1[8]?.text) ? "date" : numberlist.includes(autoselectlist1[8]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[8]?.text) ? true : false,
      width:  pharmacyWidth.includes(autoselectlist1[8]?.text) ? 288 : 144,      
      action: true,
      edit: false,
      sort: hideSortColFilterList.includes(autoselectlist1[8]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[9]?.dataField,
      text: autoselectlist1[9]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[9]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[9]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[9]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width:  pharmacyWidth.includes(autoselectlist1[9]?.text) ? 288 : 144,      
      show: autoselectlist1.length > [9] ? true : false,
      inputType: dateList.includes(autoselectlist1[9]?.text) ? "date" : numberlist.includes(autoselectlist1[9]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[9]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterList.includes(autoselectlist1[9]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[10]?.dataField,
      text: autoselectlist1[10]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[10]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[10]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[10]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      width:  pharmacyWidth.includes(autoselectlist1[10]?.text) ? 288 : 144,      
      show: autoselectlist1.length > [10] ? true : false,
      inputType: dateList.includes(autoselectlist1[10]?.text) ? "date" : numberlist.includes(autoselectlist1[10]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[10]?.text) ? true : false,
      action: true,
      edit: false,
      sort: hideSortColFilterList.includes(autoselectlist1[10]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[11]?.dataField,
      text: autoselectlist1[11]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[11]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[11]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[11]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [11] ? true : false,
      inputType: dateList.includes(autoselectlist1[11]?.text) ? "date" : numberlist.includes(autoselectlist1[11]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[11]?.text) ? true : false,
      width:  pharmacyWidth.includes(autoselectlist1[11]?.text) ? 288 : 144,      
      action: true,
      edit: false,
      sort: hideSortColFilterList.includes(autoselectlist1[11]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[12]?.dataField,
      text: autoselectlist1[12]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[12]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[12]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[12]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [12] ? true : false,
      inputType: dateList.includes(autoselectlist1[12]?.text) ? "date" : numberlist.includes(autoselectlist1[12]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[12]?.text) ? true : false,
      width:  pharmacyWidth.includes(autoselectlist1[12]?.text) ? 288 : 144,      
      action: true,
      edit: false,
      sort: hideSortColFilterList.includes(autoselectlist1[12]?.text) ? true : false,

    },
    {
      dataField: autoselectlist1[13]?.dataField,
      text: autoselectlist1[13]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[13]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[13]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[13]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [13] ? true : false,
      inputType: dateList.includes(autoselectlist1[13]?.text) ? "date" : numberlist.includes(autoselectlist1[13]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[13]?.text) ? true : false,
      width:  pharmacyWidth.includes(autoselectlist1[13]?.text) ? 288 : 144,      
      action: true,
      edit: false,
      sort: hideSortColFilterList.includes(autoselectlist1[13]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[14]?.dataField,
      text: autoselectlist1[14]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[14]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[14]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[14]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [14] ? true : false,
      inputType: dateList.includes(autoselectlist1[14]?.text) ? "date" : numberlist.includes(autoselectlist1[14]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[14]?.text) ? true : false,
      width:  pharmacyWidth.includes(autoselectlist1[14]?.text) ? 288 : 144,      
      action: true,
      edit: false,
      sort: hideSortColFilterList.includes(autoselectlist1[14]?.text) ? true : false,
    },
    {
      dataField: autoselectlist1[15]?.dataField,
      text: autoselectlist1[15]?.text,
      cellRenderer: currencylist.includes(autoselectlist1[15]?.text) ? (rowData, col) => currencyFormat(rowData[col.dataField]) : dateList.includes(autoselectlist1[15]?.text) ? (rowData, col) => dateFormate(rowData[col.dataField]) : autoselectlist1[15]?.text == "PO Number" ? (rowData) => cellRenderLink(rowData) : (rowData, col) => cellRendererCheck(rowData[col.dataField]),
      show: autoselectlist1.length > [15] ? true : false,
      inputType: dateList.includes(autoselectlist1[15]?.text) ? "date" : numberlist.includes(autoselectlist1[15]?.text) ? "number" : "text",
      hideColFilter: !hideColFilterlist.includes(autoselectlist1[15]?.text) ? true : false,
      width:  pharmacyWidth.includes(autoselectlist1[15]?.text) ? 288 : 144,      
      action: true,
      edit: false,
      sort: hideSortColFilterList.includes(autoselectlist1[15]?.text) ? true : false,
    },
  ];
  let mainCol = [
    {
      dataField: 'options',
      text: 'Options',
      sort: false,
      width: 100,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData) => cellOptionLink(rowData),
      action: true,
    },
    {
      dataField: 'poid',
      text: 'PO Number',
      sort: true,
      width: 144,
      show: true,
      inputType: 'number',
      cellRenderer: (rowData) => cellRenderLink(rowData),
    },
    {
      dataField: 'sourcePONumber',
      text: 'Source PO #',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    // {
    //   dataField: 'tpaName',
    //   text: 'Submitted By',
    //   sort: false,
    //   width: 144,
    //   show: accountype == 1 ? true : false,
    //   inputType: 'text',
    //   hideColFilter: true,
    //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    // },

    {
      dataField: 'poSource',
      text: '	PO Source',
      sort: false,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: 'accountType',
      text: 'Account Type',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: 'coveredEntityName',
      text: 'Covered Entity',
      sort: false,
      width: 288,
      show: accountype == 1 ? true : false,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: 'chainPharmacyName',
      text: 'Chain Pharmacy',
      sort: false,
      width: 288,
      show: accountype == 2 ? true : false,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    // {
    //   dataField: 'opaCode',
    //   text: 'CE OPAID ',
    //   sort: false,
    //   width: 144,
    //   show: accountype == 1 ? true : false,
    //   inputType: 'text',
    //   hideColFilter: true,
    //   cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    // },
    {
      dataField: 'pharmacyName',
      text: 'Pharmacy',
      sort: false,
      width: 288,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: 'npi',
      text: 'Pharmacy NPI',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: 'poDate',
      text: 'PO Date',
      sort: true,
      width: 144,
      show: true,
      inputType: 'date',
      cellRenderer: (rowData, col) => dateFormate(rowData[col.dataField]),
    },
    {
      dataField: 'poStatus',
      text: 'PO Status',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: 'wholesalerAccount',
      text: 'Account #',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: 'wholesaler',
      text: 'Wholesaler Name',
      sort: false,
      width: 144,
      show: true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: 'totalPackagesOrdered',
      text: 'Total Packages Ordered',
      sort: false,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: 'poPackageCost',
      text: 'Total Ordered Price',
      sort: false,
      width: 144,
      show: con == true ? false : true,
      inputType: 'number',
      hideColFilter: true,
      cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
    },
    {
      dataField: 'totalInvoicedPackages',
      text: 'Total Invoiced Packages',
      sort: false,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },
    {
      dataField: 'totalInvoicedPrice',
      text: 'Total Invoiced Price',
      sort: false,
      width: 144,
      show: con == true ? false : true,
      inputType: 'text',
      hideColFilter: true,
      cellRenderer: (rowData, col) => currencyFormat(rowData[col.dataField]),
    },
    {
      dataField: 'invoiceNumber',
      text: 'Invoice #',
      sort: false,
      width: 144,
      show: true,
      inputType: 'number',
      hideColFilter: true,
      cellRenderer: (rowData, col) => cellRendererCheck(rowData[col.dataField]),
    },

  ];

  const onHandleSort = (filter, hasColFilter) => {
    if (hasColFilter) {
      onPageChange(filter, true);
    } else {
      onPageChange(filter);
    }
  };

  const onPageSizeChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      return onPageChange(colFilterOn, true);
    }
    onPageChange(filter);
  };

  const onHandlePageChange = (filter, hasColFilter, colChangedFilter) => {
    if (hasColFilter) {
      const colFilterOn = { ...filter, filters: colChangedFilter };
      onPageChange(colFilterOn, true);
    } else {
      onPageChange(filter);
    }
  };

  const handleSearchColumnFilters = (colFilter) => {
    if (onSearchColumnFilters) {
      onSearchColumnFilters(colFilter);
    }
  };

  const handleFilterCancel = () => {

    refetch();

  };

  // const [state, updateState] = useState({
  //   AddOrderModal: false,
  // });

  // const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));

  // const onToggleAddOrderModal = () => {
  //   setState({
  //     addOrderModal: !state.addOrderModal,
  //   });
  // };
  const hasPermission = (code) => {
    return ModuleAccess("PO", code);

  }
  // const { addOrderModal } = state;

  return (
    <div>
      <h5 className="f-16 text-primary font-weight-700">
        Purchase Order Count ({totalSize})
      </h5>
    <div
      className='table-card scroll-table position-relative border-0 rounded pt-0'
      fixed-height={tableData.length > 0 ? "fixed-height" : "default"}
    >
      <ReactStrapTable
        id='inventory-table'
        height={550}
        fixedColumn
        width={1200}
        reset={reset}
        hasPagination
        loading={loading}
        data={tableData}
        columns={autoselectlist1.length > 0 ? maincol1 : mainCol}
        AllExport={AllExport}
        slelectedExport={slelectedExport}
        // slelectedExport={(accountype == 1)? slelectedExportcoloumms : slelectedNon340BExportcoloumms }
        filters={filters}
        totalRecords={totalSize}
        pageSize={filters.pageSize}
        currentPage={filters.currentPage}
        handleSort={onHandleSort}
        onPageChange={onHandlePageChange}
        onPageSizeChange={onPageSizeChange}
        onFilterCancel={handleFilterCancel}
        onSearchColumnFilters={handleSearchColumnFilters}
        hasColselect={true}
        onSelectColoums={handleselectColoums}
        hasExportPermission={hasExportPermission}
        disableSelectedColumn={disableSelectedColumn}
        toggleSider={toggleSider}
        collapseSider={collapseSider}
        enabletogglesider={true}
        autoselectlist1={autoselectlist1}>
        {/* <div style={{ marginRight: "10px" }}>
          {accountype == 1 &&
            <Button className="search" onClick={onToggleAddOrderModal} disabled={(ceIds.length != 1 || pharmacyids.length != 1) || (selectedOption.optionSelected == '-1' || selectedOpt.optSelected == '-1')} color='primary' hidden={!hasPermission('ADDPO')}>
              <span className="right_5">
                {" "}
                <img src={plus} alt="" />
              </span>{" "}  Add
            </Button>

          }
        </div> */}


        {/* {<div className='mx-4 text-light f-0 text-white font-weight-lighter border-end'>
          |
        </div>} */}

      </ReactStrapTable>
      {/* <Modal
        isOpen={addOrderModal}
        toggle={onToggleAddOrderModal}
        size='xl'
        className='addpo'
      >
        <ModalHeader toggle={onToggleAddOrderModal}>
          Add Order
        </ModalHeader>
        <ModalBody>
          <AddOrderModal isOpen={addOrderModal} toggle={onToggleAddOrderModal} tenantID={tenantID} ceid={searchTerms.ceIds} phid={searchTerms.pharmacyids} tpid={thirdPartyAdminID} refetch={refetch} />
        </ModalBody>
      </Modal> */}
      <Modal
        isOpen={coloumselect}
        toggle={handleselectColoums}
        size='lg'
        className='lg'
      >
        <ModalHeader toggle={handleselectColoums}>
          Column Selector
        </ModalHeader>
        <ModalBody>
          <DragDrop cancalcolselect={handleselectColoums} refetch={handleselectColoums} reloadautocolum={handlAutocoloms} modulename={modulename} />
        </ModalBody>
      </Modal>

      <Drawer
        direction="end"
        title="Purchase Order Details"
        isOpen={isPODetailsOpen}
        toggle={togglePODetailsDrawer}
        size="lg"
      >
        <OrderDetailsDrawer toggle={togglePODetailsDrawer} tenantID={tenantID} rowData={poRowData} onRefetch={handleFilterCancel}
          onClose={drawerPODetailsClose} accountype={accountype} Non340BTenantID={Non340BTenantID} cpId={cpId}
          setAccountype={setAccountype} />
      </Drawer>
      <Drawer
        direction="end"
        title="PO# Claims"
        isOpen={isClaimsPOOpen}
        toggle={toggleClaimsPODrawer}
        size="lg"
      >
        <ClaimsDrawer tenantID={tenantID} rowData={poRowData}
          onClose={drawerClaimsPOClose} />
      </Drawer>


      <ConfirmationDialouge
        isOpen={isAuthorizeOrderOpen}
        loading={conformLoading}
        message="Do you wish to Authorize the PO Number"
        endMessage="Please Note: Once the order is authorized, the order will be sent to the wholesaler for fulfillment. To proceed, click OK."
        onToggle={handleAuthorizeOrderConformation}
        onCancel={handleAuthorizeOrderConformation}
        onContinue={handleAuthorizeSubmit}
        data={data1}
        show={true}

      />
      <ConfirmationDialouge
        isOpen={isCancelOrderOpen}
        loading={conformLoading}
        message="Do you wish to cancel PO Number"
        endMessage=" If cancelled, the order will not be sent to the wholesaler. To proceed, click OK."
        onToggle={handleCancelOrderConfirmation}
        onCancel={handleCancelOrderConfirmation}
        onContinue={handleCancelSubmit}
        show={true}
        data={data1}
      />

      </div>

    </div>


  );
};

export default PurchaseOrderTable;
